import { render, staticRenderFns } from "./MobileAdminEvenementsTab.vue?vue&type=template&id=bf494eb6&scoped=true"
import script from "./MobileAdminEvenementsTab.vue?vue&type=script&lang=js"
export * from "./MobileAdminEvenementsTab.vue?vue&type=script&lang=js"
import style0 from "./MobileAdminEvenementsTab.vue?vue&type=style&index=0&id=bf494eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf494eb6",
  null
  
)

export default component.exports